import {
  HomePage,
  Declaration,
  Proposer,
  Vehicles,
  Drivers,
  Quote,
  Payment,
  Complete,
} from './scenes';
import { IChannel, IPolicyApplication, IStep } from '../../data/api/models';
import { Component } from 'react';

export interface IReactStep extends IStep {
  component: Component;
}

const componentKeyMap = {
  homePage: HomePage,
  declaration: Declaration,
  proposer: Proposer,
  vehicles: Vehicles,
  drivers: Drivers,
  quote: Quote,
  payment: Payment,
  complete: Complete,
};

function mapComponentsFromKey(step): IReactStep {
  return {
    ...step,
    component: componentKeyMap[ step.key ],
  };
}

export default (channel?: IChannel): IReactStep[] => {
  const defaultSteps: IStep[] = [
    {
      title: 'Declaration',
      key: 'declaration',
      route: '/',
      saveApplication: true,
      saveApplicationWithPatch: false,
      calculatePremium: false,
      showReferrals: false,
      keepDataWhenLeaving: true,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Proposer',
      key: 'proposer',
      route: '/proposer',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: false,
      keepDataWhenLeaving: true,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Vehicle(s)',
      key: 'vehicles',
      route: '/vehicles',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: true,
      keepDataWhenLeaving: true,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Drivers',
      key: 'drivers',
      route: '/drivers',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: true,
      keepDataWhenLeaving: true,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Quote',
      key: 'quote',
      route: '/quote',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: true,
      keepDataWhenLeaving: false,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Payment',
      key: 'payment',
      route: '/payment',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: true,
      keepDataWhenLeaving: false,
      enabled: (formValues: IPolicyApplication) => true,
    },
    {
      title: 'Payment Complete',
      key: 'complete',
      route: '/complete',
      calculatePremium: true,
      saveApplication: true,
      saveApplicationWithPatch: false,
      showReferrals: true,
      keepDataWhenLeaving: false,
      enabled: (formValues: IPolicyApplication) => true,
    },
  ];

  const config = channel.steps ? channel.steps : defaultSteps;

  return config.map(mapComponentsFromKey);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/steps.tsx